import { compose, withHandlers } from 'recompose';
import { addProps } from 'utils/recompose';
import styles from './styles.module.scss';

const optionStyles = ({ alternativeTemplateId, selectedTemplateId }) =>
  alternativeTemplateId === selectedTemplateId
    ? styles.optionIconSelected
    : styles.optionIcon;

const onClick = ({
  alternativeTemplateId,
  selectTemplateId,
  selectedTemplateId,
}) => () => {
  selectTemplateId(alternativeTemplateId, selectedTemplateId);
};

export default compose(addProps({ optionStyles }), withHandlers({ onClick }));
